import { RouteConfig } from 'vue-router';

const PAGE_TITLE = '九童圆梦鼠年春节行动';

const route: RouteConfig = {
  path: '/20200118JTYM',
  name: 'JTYM',
  component: () => import('./Home.vue'),
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'List',
      component: () => import('./List.vue'),
      name: 'List',
      meta: {
        title: PAGE_TITLE,
        keepAlive: true, // 需要被缓存的组件
      },
      children: [
        {
          path: ':source',
          component: () => import('./List.vue'),
          name: 'List',
          meta: {
            title: PAGE_TITLE,
          },
        },
      ],
    },
    {
      path: 'Rules',
      component: () => import('./Rules.vue'),
      name: 'Rules',
      meta: {
        title: PAGE_TITLE,
        keepAlive: true, // 需要被缓存的组件
      },
    },
    {
      path: 'Ranking',
      component: () => import('./Ranking.vue'),
      name: 'Ranking',
      meta: {
        title: PAGE_TITLE,
        keepAlive: true, // 需要被缓存的组件
      },
    },
    {
      path: 'User',
      component: () => import('./User.vue'),
      name: 'User',
      meta: {
        title: PAGE_TITLE,
        keepAlive: true, // 需要被缓存的组件
      },
    },
    {
      path: 'Uploading',
      component: () => import('./Uploading.vue'),
      name: 'Uploading',
      meta: {
        title: PAGE_TITLE,
        keepAlive: true, // 需要被缓存的组件
      },
    },
    {
      path: 'Detail',
      component: () => import('./Detail.vue'),
      name: 'Detail',
      meta: {
        title: PAGE_TITLE,
        keepAlive: false,
      },
    },
  ],
};

export default route;
